/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_SubtitleInputs */

const cs_billing_subtitle = /** @type {(inputs: Billing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zůstatky pro AI. Nejdřív se čerpá osobní peněženka, pak firemní alokace — stejně pro jednoho makléře i kancelář se 200 lidmi.`)
};

const en_billing_subtitle = /** @type {(inputs: Billing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI usage balances. Personal wallet is spent before organization allocation — same for a solo RK or a 200-broker office.`)
};

/**
* | output |
* | --- |
* | "AI usage balances. Personal wallet is spent before organization allocation — same for a solo RK or a 200-broker office." |
*
* @param {Billing_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_subtitle = /** @type {((inputs?: Billing_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_subtitle(inputs)
	return cs_billing_subtitle(inputs)
});